import Axios from 'axios'


export async function fetchCurrencies() {
    let response
    try {
        const options = {
            method: 'GET',
            url: 'https://currency-converter5.p.rapidapi.com/currency/list',
            headers: {
              'x-rapidapi-key': '4a924e26e2msh6cbbda7a5553cb0p10cffcjsn999d1a4b9b45',
              'x-rapidapi-host': 'currency-converter5.p.rapidapi.com'
            }
          };
        
          response = await Axios.request(options)
    } catch (error) {
        console.log(error)
        response = "fail"
    }
    return response
}

export async function convertCurrencies(from, to, amount) {
    let response
    try {
        const options = {
            method: 'GET',
            url: 'https://currency-converter5.p.rapidapi.com/currency/convert',
            params: {format: 'json', from: from, to: to, amount: amount},
            headers: {
              'x-rapidapi-key': '4a924e26e2msh6cbbda7a5553cb0p10cffcjsn999d1a4b9b45',
              'x-rapidapi-host': 'currency-converter5.p.rapidapi.com'
            }
          };
          
          response = await Axios.request(options);
    } catch (error) {
        response = "fail"
    }
    return response
}